import { computed } from 'vue';
import type { Airline } from '../../../shared/ui';

export const getIconsDisplayData = (
  displayCirclesAmount: number,
  airlines: Airline[],
) => {
  const airlinesAmount = airlines.length;

  const shouldHideAirlines = computed(
    () => airlinesAmount > displayCirclesAmount,
  );
  const croppedAirlines = computed(() => {
    if (shouldHideAirlines.value) {
      return airlines.slice(0, displayCirclesAmount - 1);
    }
    return airlines.slice(0, displayCirclesAmount);
  });
  const hiddenAirlinesAmount = computed(
    () => airlinesAmount - croppedAirlines.value.length,
  );

  return {
    shouldHideAirlines,
    croppedAirlines,
    hiddenAirlinesAmount,
  };
};
